import React, { useEffect } from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb, PartnerForm, AlertError, Button, PartnerFormEdit, PartnerView } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import { setActivePartnerForm, updatePartner } from '../../features/organization-form/slice'
import adapter, { subAdapter } from '../../features/organization-form/adapter'
import { updateOrganizationDirect } from '../../features/organizations/slice'
import { errorHandler, useViewport } from '../../utils'
import { toast } from 'react-toastify'
import { fetchOrganization } from '../../features/organization/slice'
import { useHistory } from 'react-router-dom'
import service from '../../features/organizations/service'
import { useInternationalization } from '../../features/i18n'

/**
 * ORGANIZATION PARTNER FORM
 */

/**
 * @todo optimize dashboard profile routing
 */

const DashboardPartnersForm = ({ match, ...props }) => {
  const id = match.params.id
  const [isEdit, setIsEdit] = React.useState(id)
  const { isMobile, isDesktop } = useViewport()
  const dispatch = useDispatch()
  const history = useHistory()
  const [requesting, setRequesting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(null)
  const profile = useSelector(state => state.account.profile)
  const organizationForm = useSelector(state => state.organizationForm.data)
  const partnerForm = useSelector(state => state.organizationForm.partner)
  const { active_form, partners_external } = partnerForm
  const [selectedPartner, setSelectedPartner] = React.useState(organizationForm.partners_external.find(p => p.pkId === id))
  const [noImage, setNoImage] = React.useState(false)
  const { translate } = useInternationalization()

  const routes = [
    {
      name: translate('NAVIGATION', 'dashboard'),
      route: '/dashboard'
    },
    {
      name: translate('ORGANIZATION', 'profile'),
      route: '/dashboard/organization/profile'
    },
    {
      name: translate('PARTNER', 'plural'),
      route: '/dashboard/organization/profile/partners'
    }
  ]

  useEffect(() => {
    if(organizationForm){
      setSelectedPartner(organizationForm.partners_external.find(p => p.pkId === id))
    }
  }, [organizationForm, id])

  const {
    partners,
    partners_saved,
    // partners_external,
    partners_external_saved,
    id: organizationId
  } = organizationForm

  const handleCancel = () => {
    dispatch(setActivePartnerForm('internal'))
  }

  const handleSubmit = async (e) => {
    if(e && e.preventDefault && typeof e.preventDefault === 'function'){
      e.preventDefault()
    }

    setRequesting(true)
    setErrorMessage(null)

    // Send to backend
    const promise1 = handleInternal()
    const promise2 = handleExternal()

    return Promise.all([promise1, promise2])
      .then(res => {
        toast.success('Successfully updated!')
        if(organizationId){
          dispatch(fetchOrganization(organizationId))
          history.push('/dashboard/organization/profile/partners')
        }
      })
      .catch(err => {
        const msg = errorHandler(err)
        setErrorMessage(msg)
      })
      .then(() => setRequesting(false))

    async function handleInternal(){
      // Handle internal partners
      return dispatch(updateOrganizationDirect({
        id: profile.organizationId,
        data: adapter.formToRequestBody(partnerForm, 'partners'),
      }))
    }

    async function handleExternal(){
      if(partners_external && partners_external.length > 0){
        // Handle external partners
        const requestBody = {
          partnerOrganisasiEksternal: partners_external.map(p => subAdapter.partner.external.formToRequestBody(p))
        }
        return dispatch(updateOrganizationDirect({
          id: profile.organizationId,
          data: requestBody
        }))
      }

      return false
    }
  }

  const removeItemSaved = (id) => {

  }

  const removeItemExternalSaved = () => {

  }

  const handleEditSaved = () => {

  }

  const removeItem = (id, pkId) => {
    if(pkId){
      service.deletePartner(pkId)
        .then(res => {
          toast.success('Sucessfully deleted.')
          history.push('/dashboard/organization/profile/partners')
        })
        .catch(err => {
          const msg = errorHandler(err)
          toast.error(msg)
        })
    }
  }

  const removeItemExternal = (id) => {
    if(id){
      dispatch(updatePartner({
        key: 'partners_external',
        value: partners_external.filter(p => p.id !== id)
      }))
    }
  }

  const handleEdit = (id) => {
    const obj = partners_external.find(p => p.id === id)
    if(obj){
      setNoImage(true)
      setSelectedPartner(obj)
      setIsEdit(true)
    }
  }

  return (
    <DashboardLayout title="Add New / Edit Partner">
      {
        isDesktop &&
        <div>
          <Breadcrumb routes={routes}/>
          <h1 className="text-4xl font-primary font-bold">
            {isEdit ? 'Edit Partner' : translate('PARTNER', 'add')}
          </h1>
          <hr className="mt-5 mb-8"/>
        </div>
      }
      {
        isEdit &&
        // <div>Sorry, partner editing is not available yet.<br/> [Status: working on it.]</div>
        <PartnerFormEdit
          storeKey="organizationForm"
          defaultValue={selectedPartner}
          setIsEdit={setIsEdit}
          noImage={noImage}
        />
      }
      {
        !isEdit &&
        <div className="xl:w-2/3">
          <div className="mb-5 lg:mb-8">
            <PartnerForm
              storeKey="organizationForm"
              setActivePartnerForm={setActivePartnerForm}
              form={partnerForm}
              updateForm={updatePartner}
              handleCancel={handleCancel}
              excludes={partners.map(p => p.id)}
            />

            {
              active_form === 'internal' &&
              <div className="lg:w-1/3">
                {
                  (partners_saved || partners_external_saved) &&
                  <PartnerView
                    internals={partners_saved}
                    externals={partners_external_saved}
                    onRemove={removeItemSaved}
                    onRemoveExternal={removeItemExternalSaved}
                    onEdit={handleEditSaved}
                  />
                }
                {
                  (partners || partners_external) &&
                  <PartnerView
                    internals={partners}
                    externals={partners_external}
                    onRemove={removeItem}
                    onRemoveExternal={removeItemExternal}
                    onEdit={handleEdit}
                  />
                }
              </div>
            }
          </div>
          {
            active_form === 'internal' &&
            <Button
              style={!isMobile ? {width: '197px'} : {}}
              thin={isMobile}
              disabled={requesting}
              isLoading={requesting}
              onClick={handleSubmit}
            >
              <span>{translate('GENERAL', 'save')}</span>
            </Button>
          }
          {
            errorMessage &&
            <AlertError
              message={errorMessage}
              onClose={() => setErrorMessage(null)}
            />
          }
        </div>
      }
    </DashboardLayout>
  )
}

export { DashboardPartnersForm }
